import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  parentLikeActivityMutationData: any;
  parentLikeActivityMutationLoading: boolean;
  parentLikeActivityMutationError: SerializedError | null;
} = {
  parentLikeActivityMutationData: {},
  parentLikeActivityMutationLoading: false,
  parentLikeActivityMutationError: null,
};

export const parentLikeActivityMutationFunc = createAsyncThunk(
  'parentLikeActivityMutation/parentLikeActivityMutationFunc',
  async (values: { activityId: null | string }) => {
    const accessTokenJSON = localStorage.getItem('auth') as string;
    const data1 = JSON.stringify({
      query: `mutation ParentLikeActivity($activityId: String) {
        parent_likeActivity(activityId: $activityId) {
            _id
        }
    }`,
      variables: {
        activityId: values.activityId,
      },
    });

    const config = initialConfig(
      process.env.REACT_APP_BASE_URL_ACTIVITY || '',
      data1,
      accessTokenJSON ? JSON.parse(accessTokenJSON).accessToken : ''
    );

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const parentLikeActivityMutation = createSlice({
  name: 'parentLikeActivityMutation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(parentLikeActivityMutationFunc.pending, (state) => {
      state.parentLikeActivityMutationLoading = true;
    });
    builder.addCase(parentLikeActivityMutationFunc.fulfilled, (state, action) => {
      state.parentLikeActivityMutationLoading = false;
      state.parentLikeActivityMutationData = action.payload?.data?.parentLikeActivityMutation;
      state.parentLikeActivityMutationError =
        action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(parentLikeActivityMutationFunc.rejected, (state, action) => {
      state.parentLikeActivityMutationLoading = false;
      state.parentLikeActivityMutationError = action.error;
    });
  },
});

export default parentLikeActivityMutation.reducer;
